import React from 'react'
import TabView from '../components/TabView'

const SewingTab = ({tab, data}) => <TabView tab={tab} data={data}/>

export default SewingTab
